import classNames from 'classnames';
import styles from './Rating.module.scss';
import { Paragraph } from 'ui/components';

export interface RatingProps {
	className?: string;
	paragraph?: string;
}

const ratingStars = [1, 2, 3, 4, 5];

export const Rating: React.FC<RatingProps> = ({ className, paragraph }) => (
	<div className={classNames(styles.Rating, className)}>
		<div className={styles.Rating}>
			<fieldset className={styles.Rating_Wrapper}>
				<legend className={styles.Rating_legend}>Rating</legend>
				{ratingStars.map((starValue, index) => {
					return (
						<>
							<input type="radio" id={'star' + { starValue }} name="rating" value={starValue} key={index} />
							<label htmlFor={'star' + { starValue }}>{starValue} stars</label>
						</>
					);
				})}
			</fieldset>
		</div>
		<Paragraph className={styles.Rating_Text}>{paragraph}</Paragraph>
	</div>
);
